<template>
	<v-container>
		<VForm ref="form">
			<p>
				Pour poursuivre le transfert, merci de selectionner le N° AM de
				destination, puis cliquer sur le bouton "CONFIRMER LE TRANSFERT"
			</p>
			<p>N° AM actuel(s) : {{ numeroAMActuels }}</p>
			<AmeliproSelect
				id="numAmCible"
				v-model="numAmCible"
				bg-white
				:items="numAmCibles"
				label="N° AM de destination"
				aria-required
			/>
		</VForm>
	</v-container>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);
	import { Refs, VForm } from '@cnamts/vue-dot/src/types';
	import { ItemSelect } from '@/services/api/types';
	import { mapAttributes, getErreurAvecMessage } from '@/services/Utils';
	import { getAmCibleFromApi } from '@/services/api/api';
	import { store } from '@/store';

	@Component<Transfert>({
		created() {
			this.fetchData();
		},
		watch: {
			numAmCible() {
				// Exécuter une action lorsque la valeur de numAmCible change
				this.emitSelectedValue();
			}
		}
	})
	export default class Transfert extends MixinsDeclaration {
		$refs!: Refs<{
			form: VForm;
		}>;

		numAmCibles: ItemSelect[] = [];
		numAmCible = '';
		numeroAMActuels = '';

		async fetchData(): Promise<void> {
			try {
				const response = await getAmCibleFromApi(
					this.utilisateurExterneInfo.executant
				);

				if (response && 'data' in response && response.data.numAmCibles) {
					const numAmCibles = response.data.numAmCibles;
					this.numAmCibles = mapAttributes(numAmCibles);
				}
			} catch (error) {
				const messageErreur = getErreurAvecMessage(error);
				store.dispatch('notification/add', {
					type: 'error',
					message: messageErreur
				});
			}
		}

		emitSelectedValue(): void {
			this.$emit('num-am-cible', this.numAmCible);
		}

		updateNumeroAMActuels(numAmConcernes: string[]): void {
			const uniqueValues = Array.from(new Set(numAmConcernes));
			// S'assure les modifications apportées aux objets réactifs sont détectées par le système de réactivité de Vue
			Vue.set(this, 'numeroAMActuels', uniqueValues.join(','));
		}

		mounted() {
			this.$root.$on('numeroam-concernes', this.updateNumeroAMActuels);
		}

		// Optimisation. Nettoyage ecouteurs dévènements
		beforeDestroy() {
			this.$root.$off('numeroam-concernes', this.updateNumeroAMActuels);
		}
	}
</script>
